import {createModel} from '@@/package/utils/ModelUtil';
import Model from '@@/package/mapper/Model';
import {TrackLevelModel} from "~~/package/mapper/track/model/TrackLevelModel";
import {TrackType} from "~~/package/mapper/track/model/TrackType";
import {TrackLearningType} from "~~/package/mapper/track/model/TrackLearningType";
import { TrackStatusType } from "~~/package/mapper/track/model/TrackStatusType";

export class TrackModel extends Model {
    constructor(
        public id: number = 0,
        public title: string = "",
        public description: string = "",
        public briefDescription: string = "",
        public difficulty: string = "",
        public category: string = "",
        public categories: string[] = [],
        public status: TrackStatusType = TrackStatusType.NOT_STARTED,
        public learningStatus: TrackStatusType = TrackStatusType.NOT_STARTED,
        public practiceStatus: TrackStatusType = TrackStatusType.NOT_STARTED,
        public trackLevelV2DTOList: TrackLevelModel[] = [],
        public type: TrackType = TrackType.NONE,
        public trackPath: string[] = [],
        public assessmentType: TrackLearningType = TrackLearningType.LEARNING,
    ) {
        super();
    }

    public static create(model: Partial<TrackModel>): TrackModel {
        return createModel<TrackModel>(TrackModel, {
            ...model
        });
    }

    public get isLearningTrack() {
        return this.trackLevelV2DTOList
            .map(level => level.courseIdList)
            .flat()
            .length > 0
    }

    public get isAssessmentTrack() {
        return this.trackLevelV2DTOList
            .map(level => level.minAssessmentCount + level.maxAssessmentCount)
            .reduce((accumulator, currentValue) => {
                return accumulator + currentValue
            },0) > 0
    }

    public get totalCourseCount() {
        return this.trackLevelV2DTOList
            .map(level => level.courseIdList)
            .flat()
            .length
    }

    public get totalLearningTime() {
        return this.trackLevelV2DTOList
            .map(level => level.totalLearningTime)
            .reduce((accumulator, currentValue) => {
                return accumulator + currentValue
            },0)
    }

    public static isGeneralLevel(trackLevelList: Array<{ level: number }>) {
        return trackLevelList.length === 1 && trackLevelList[0].level === 0
    }
}
